export const testimonials = [
  {
    name: 'Priya Patel',
    avatar: 'https://cdn-icons-png.flaticon.com/128/6997/6997662.png',
    text: 'Maine apne ghar ke liye plywood yahan se liya tha. Quality bahut acchi hai aur price bhi reasonable. Definitely recommend karungi!',
    stars: 5,
  },
  {
    name: 'Rajesh Kumar',
    avatar: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
    text: 'Excellent service and product quality. Maine office renovation ke liye hardware yahan se purchase kiya. Staff bahut helpful hai.',
    stars: 5,
  },
  {
    name: 'Sunita Verma',
    avatar: 'https://cdn-icons-png.flaticon.com/128/6997/6997662.png',
    text: 'Kitchen cabinets ke liye plywood liya tha. Finish perfect hai aur durability bhi acchi hai. Price bhi competitive hai.',
    stars: 4,
  },
  {
    name: 'Amit Singh',
    avatar: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
    text: 'Best hardware store in the area. Quality products with reasonable pricing. Delivery bhi time pe hui. Highly satisfied!',
    stars: 5,
  },
  {
    name: 'Meera Iyer',
    avatar: 'https://cdn-icons-png.flaticon.com/128/6997/6997662.png',
    text: 'Furniture making ke liye plywood purchase kiya. Quality bahut acchi hai aur variety bhi milti hai. Will definitely come back.',
    stars: 4,
  },
  {
    name: 'Vikram Malhotra',
    avatar: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
    text: 'Professional service and excellent product range. Hardware items ki quality top-notch hai. Staff knowledgeable hai.',
    stars: 5,
  },
  {
    name: 'Anjali Desai',
    avatar: 'https://cdn-icons-png.flaticon.com/128/6997/6997662.png',
    text: 'Home renovation project ke liye yahan se materials liye. Quality excellent hai aur price bhi affordable. Great experience!',
    stars: 5,
  },
  {
    name: 'Suresh Reddy',
    avatar: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
    text: 'Contractor hun, regularly yahan se materials leta hun. Consistent quality and reliable supply. Best supplier hai.',
    stars: 4,
  },
  {
    name: 'Kavita Sharma',
    avatar: 'https://cdn-icons-png.flaticon.com/128/6997/6997662.png',
    text: 'Wardrobe ke liye plywood liya tha. Design perfect hai aur finish bhi accha hai. Customer service bahut acchi hai.',
    stars: 5,
  },
  {
    name: 'Rahul Gupta',
    avatar: 'https://cdn-icons-png.flaticon.com/512/3135/3135715.png',
    text: 'Office furniture project ke liye hardware yahan se liya. Quality products with competitive pricing. Highly recommended!',
    stars: 5,
  }
]; 